import { inferParsed, Schema } from '../../core/schemas';
import type { CredentialBlob, Json } from './types';

export class CredentialDocument {
    protected async blobToJson(input: CredentialBlob): Promise<Json> {
        try {
            return JSON.parse(await input.text());
        } catch (err) {
            console.error(err);
            throw new Error('Invalid JSON in Credential Blob');
        }
    }

    protected parseJson<T extends Schema<any, any>>(schema: T, input: Json): inferParsed<T> {
        return schema.parseOrThrow(input, {
            unrecognizedObjectKeys: 'passthrough',
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
        });
    }

    protected async parseBlob<T extends Schema<any, any>>(schema: T, input: CredentialBlob): Promise<inferParsed<T>> {
        return this.parseJson(schema, await this.blobToJson(input));
    }
}
